import React, { useContext } from 'react';
import set from 'lodash/set';

import DatePicker from 'src/presentation/components/forms/DatePicker';
import FormContext from 'src/presentation/contexts/FormContext';

const AbsoluteTimeControl = ({
  attr,
  'data-aid': dataAid,
  disabled,
}: {
  attr: string;
  'data-aid'?: string;
  disabled: boolean;
}) => {
  const { onBlur } = useContext(FormContext);

  const handleChangeDatePicker = (val: string) => {
    const newVal = set({}, `${attr}.date`, val);
    onBlur && onBlur({ currentState: newVal });
  };

  return (
    <DatePicker
      attr={`${attr}.date`}
      data-aid={`${dataAid}-date`}
      disabled={disabled}
      onChange={handleChangeDatePicker}
    />
  );
};

export default AbsoluteTimeControl;
